import {Component, Prop, Watch, Vue} from 'vue-property-decorator';

@Component
export default class SettingsTabMixin extends Vue {
    @Prop() data!: any;
    @Prop() initialData!: any;
    @Prop() tabKey!: number;

    protected localData: any = this.data;

    @Watch('data', {deep: true})
    onDataChange(value: any) {
        this.localData = value;
    }

    @Watch('localData', {deep: true})
    onLocalDataChange(value: any) {
        this.$emit('update:data', value);
    }

    validate() {
        return {
            valid: this.$refs.form ? (this.$refs.form as any).validate() : true,
            tab: this.tabKey,
        };
    }
}
